module.exports = __webpack_public_path__ + "img/guzhiReport3.254a9440.png";